import { render, staticRenderFns } from "./AppointmentsNotification.vue?vue&type=template&id=19f0950a&scoped=true&"
import script from "./AppointmentsNotification.vue?vue&type=script&lang=js&"
export * from "./AppointmentsNotification.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsNotification.vue?vue&type=style&index=0&id=19f0950a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f0950a",
  null
  
)

export default component.exports